const { BASE_URL } = require("./client");

const ONBOARDING_GET_API = BASE_URL + "/api/onboarding";

module.exports = {
  ONBOARDING_GET_API,
};
